import { globalConstants, roleConstants } from "../../constants";

//Destructuring global constants
const { SUCCESS } = globalConstants;

//Default state of admin reducer
const initialState = {
  spinnerActive: false
};

export const spinnerReducer = (state = initialState, action) => {
  switch (action.type) {
    case globalConstants.SPINNER_ACTIVATE + SUCCESS:
      return { ...state, spinnerActive: action.data };
    default:
      return state;
  }
};
